import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Card } from 'src/app/models/card.model';
import { CardsService } from 'src/app/services/cards.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfigKeys } from 'src/app/config/config.keys';
import { ShowCardService } from 'src/app/services/ShowCard.service';

@Component({
  selector: 'app-cards',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.css']
})
export class CardsComponent implements OnInit {
  // @Output() selectedCard = new EventEmitter<number>();
  cards: Card[] = [];
  cardsCredit: Card[] = [];
  cardsDebit: Card[] = [];
  selectedCardId: number=0;

  configKeys: ConfigKeys = new ConfigKeys();

 constructor(
   private cardsService: CardsService,
   private router: Router,
   private route: ActivatedRoute,
   private showCardService: ShowCardService
 ) { }

 ngOnInit() {

     // var lastIdCard = this.route.snapshot.params['idCard'];

     // console.log('ID_CARD_FROM CARDS--->' + lastIdCard);
/*
       if(lastIdCard===undefined)
           lastIdCard=0;
           else
              lastIdCard-=1;

              this.showCardService.setSelectedCard('' + lastIdCard);*/

    this.cardsService.getCards()
    .subscribe(
      (cards: Card[]) => {

         this.cards = cards;
         this.cardsService.setCards(cards);
        // console.log('ALL_CARDS: ' + this.cards);
        // console.log('ALL_CARDS: ' + JSON.stringify(this.cards));

         this.cardsCredit = this.cards.filter(card => card.tipoTarjeta === 1);

         this.cardsDebit = this.cards.filter(card => card.tipoTarjeta === 0);

         // console.log('CREDIT: ' + this.cardsCredit);
         // console.log('DEBIT: ' + this.cardsDebit);

      }
    );


 }


 selectCard(cardId: number){

   // console.log('Executing method selectCard: ' + cardId);

   this.selectedCardId = cardId;
   this.router.navigate(['cardPromos',this.selectedCardId, 1],{skipLocationChange: true, replaceUrl: false});


 }


 /*onSelectCard(event: Event){

    let idCard = (Number)((<HTMLImageElement>event.target).id);

    this.setSelectedCardOn(idCard);

    this.selectedCard.emit(idCard);


 }


 onSelectCardSmall(event: Event){

  let idCard = (Number)((<HTMLImageElement>event.target).id);
   this.setSelectedCardOn(idCard);

   //this.selectedCard.emit(idCard);

  window.location.href = this.configKeys.URL_APP_MAIN + 'init/' + idCard + '/1';

}

  setSelectedCardOn(idCard: number){

     this.cards.forEach(card => {

              if(idCard===card.idTarjeta)
                card.displayCardOn='inline';
              else
                card.displayCardOn='';

         });

  }*/


}
